import { IExportMenuItem, Percent } from '@amcharts/amcharts4/core';

import { GraphNode, OwnershipGraphLinkResult } from '../../../../../../generated/model/models';

// Icons
export interface IconsType {
  PERSON: string;
  COMPANY: string;
}

export const Icons = {
  PERSON:
    'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  COMPANY:
    'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z',
} as Record<GraphNode.EntityTypeEnum, string>;

export enum OwnershipNodesColorEnum {
  MAIN_COMPANY = '#006DC6',
  COMPANY = '#29435D',
  PERSON = '#748698',
  LINK = '#748698',
  LABEL = '#999999',
}

export const OwnershipGraphNodeTypeEnum = {
  COMPANY: 'COMPANY',
  PERSON: 'PERSON',
} as Record<OwnershipGraphLinkResult.TypeEnum, OwnershipGraphLinkResult.TypeEnum>;

export interface OwnershipMappedGraphNode extends OwnershipGraphLinkResult {
  path: string;
  level: number;
  linkWith?: string[];
  color?: string;
  nodeValueText?: string;
  countryLabel?: string;
  x?: Percent;
  y?: Percent;
  fixed?: boolean;
}

export const dataJSON = {
  id: '10069920',
  name: 'JENSEN & JENSEN RIBE ApS',
  country: 'dk',
  links: [
    {
      id: '4004070853',
      name: 'Jens-Ejnar Madsen',
      country: 'dk',
      type: 'PERSON',
      value: '33.33%',
      nodeValue: 33.33,
      links: [
        {
          id: '18598666',
          name: 'JENSEN & JENSEN HOLDING A/S',
          country: 'dk',
          type: 'COMPANY',
          value: '66.67%',
          nodeValue: 66.67,
        },
        {
          id: '18598665',
          name: 'JENSEN & JENSEN HOLDING A/S',
          country: 'dk',
          type: 'COMPANY',
          value: '66.67%',
          nodeValue: 66.67,
        },
        {
          id: '18598664',
          name: 'JENSEN & JENSEN HOLDING A/S',
          country: 'dk',
          type: 'COMPANY',
          value: '66.67%',
          nodeValue: 66.67,
        },
        {
          id: '18598663',
          name: 'JENSEN & JENSEN HOLDING A/S',
          country: 'dk',
          type: 'COMPANY',
          value: '66.67%',
          nodeValue: 66.67,
        },
        {
          id: '18598662',
          name: 'JENSEN & JENSEN HOLDING A/S',
          country: 'dk',
          type: 'COMPANY',
          value: '66.67%',
          nodeValue: 66.67,
        },
        {
          id: '18598661',
          name: 'JENSEN & JENSEN HOLDING A/S',
          country: 'dk',
          type: 'COMPANY',
          value: '66.67%',
          nodeValue: 66.67,
        },
      ],
    },
    {
      id: '18598442',
      name: 'JENSEN & JENSEN HOLDING A/S',
      country: 'dk',
      type: 'COMPANY',
      value: '66.67%',
      nodeValue: 66.67,
      links: [
        {
          id: '31626714',
          name: 'LJ HOLDING ESBJERG ApS',
          country: 'dk',
          type: 'COMPANY',
          value: '50.0%',
          nodeValue: 33.34,
          links: [
            {
              id: '36405465',
              name: 'LJ HOLDING 2014 A/S',
              country: 'dk',
              type: 'COMPANY',
              value: '50.0%',
              nodeValue: 16.67,
              links: [
                {
                  id: '4003961035',
                  name: 'Lars Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '100.0%',
                  nodeValue: 16.67,
                  links: [],
                },
              ],
            },
            {
              id: '36200448',
              name: 'ANNE JENSEN, ESBJERG ApS',
              country: 'dk',
              type: 'COMPANY',
              value: '15.0%',
              nodeValue: 5,
              links: [
                {
                  id: '4004174814',
                  name: 'Anne Kissow Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '90.0%',
                  nodeValue: 4.5,
                  links: [],
                },
                {
                  id: '4003961035',
                  name: 'Lars Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '0%',
                  nodeValue: 16.67,
                  links: [],
                },
              ],
            },
            {
              id: '36200472',
              name: 'JULIE JENSEN, ESBJERG ApS',
              country: 'dk',
              type: 'COMPANY',
              value: '15.0%',
              nodeValue: 5,
              links: [
                {
                  id: '4004177084',
                  name: 'Julie Simone Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '90.0%',
                  nodeValue: 4.5,
                  links: [],
                },
                {
                  id: '4003961035',
                  name: 'Lars Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '0%',
                  nodeValue: 16.67,
                  links: [
                    {
                      id: '40041770000',
                      name: 'Julie Simone Jensen',
                      country: 'dk',
                      type: 'PERSON',
                      value: '90.0%',
                      nodeValue: 4.5,
                      links: [
                        {
                          id: '40041770100',
                          name: 'Julie Simone Jensen',
                          country: 'dk',
                          type: 'PERSON',
                          value: '90.0%',
                          nodeValue: 4.5,
                          links: [
                            {
                              id: '40041770110',
                              name: 'Julie Simone Jensen',
                              country: 'dk',
                              type: 'PERSON',
                              value: '90.0%',
                              nodeValue: 4.5,
                              links: [],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: '31626722',
          name: 'FLEMMING JENSEN HOLDING ESBJERG ApS',
          country: 'dk',
          type: 'COMPANY',
          value: '50.0%',
          nodeValue: 33.34,
          links: [
            {
              id: '36200367',
              name: 'KRISTOFFER JENSEN, ESBJERG ApS',
              country: 'dk',
              type: 'COMPANY',
              value: '20.0%',
              nodeValue: 6.67,
              links: [
                {
                  id: '4004188803',
                  name: 'Kristoffer Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '90.0%',
                  nodeValue: 6,
                  links: [],
                },
                {
                  id: '4000615975',
                  name: 'Helle Schmidt Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '0%',
                  nodeValue: 0,
                  links: [],
                },
                {
                  id: '4003961036',
                  name: 'Flemming Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '0%',
                  nodeValue: 16.67,
                  links: [],
                },
              ],
            },
            {
              id: '36403586',
              name: 'FLEMMING JENSEN HOLDING 2014 A/S',
              country: 'dk',
              type: 'COMPANY',
              value: '50.0%',
              nodeValue: 16.67,
              links: [
                {
                  id: '4003961036',
                  name: 'Flemming Jensen',
                  country: 'dk',
                  type: 'PERSON',
                  value: '100.0%',
                  nodeValue: 16.67,
                  links: [],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const exportMenu: IExportMenuItem = {
  label: '...',
  menu: [
    {
      label: 'Image',
      menu: [
        { type: 'jpg', label: 'JPG' },
        { type: 'pdf', label: 'PDF' },
      ],
    },
    {
      label: 'Data',
      menu: [
        { type: 'json', label: 'JSON' },
        { type: 'csv', label: 'CSV' },
        { type: 'xlsx', label: 'XLSX' },
      ],
    },
  ],
};
